// @ts-nocheck
import React, { useState } from 'react';
import { Form, InputGroup } from "react-bootstrap";
import "./Inputs.scss";

import { ImUpload2 } from "react-icons/im";

const FileInput: React.FC<{
  label?: string;
  txt: string;
  iconTxt?: string;
  onChangeFunc: (e: FileList | null) => void;
  id: string;
  accept?: string;
}> = ({
  txt = "",
  iconTxt = "انتخاب کنید...",
  id = "",
  onChangeFunc = (e: FileList | null) => { },
  label = "",
  accept = "*",
}) => {
    const [fileNames, setFileNames] = useState<string[]>([]);

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {

      const files = e.target.files[0];
      const names: string[] = [];

      if (files) {
        // for (let i = 0; i < files.length; i++) {
        names.push(files.name);
        // }
      }

      setFileNames(names);
      onChangeFunc(e);
    };
    const formatFileName = (fileName: string) => {
      const maxLength = 40;
      if (fileName.length > maxLength) {
        return fileName.substring(0, maxLength) + '...';
      }
      return fileName;
    };
    return (
      <>
        <label htmlFor={id} className="w-100 file-input">
          <Form.Control type="file" id={id} hidden accept={accept} onChange={handleFileChange} />
          <label>{label}</label>
          <div
            className="d-flex justify-content-between align-items-center rounded-pill  p-1"
            style={{
              border: ` 2px solid #69809a`,
              // borderImage:
              //   "linear-gradient(to right, rgb(215, 215, 177), beige,rgb(226 226 197)) 1",
              // borderRadius: 20,
              fontSize: 14,
            }}
          >
            <div className="ms-2 me-1 main-text" style={{ height: 20 }}>
              {fileNames.length > 0
                ? fileNames.map((fileName, index) => (
                  <span key={index} title={fileName}>
                    {formatFileName(fileName)}
                    {index !== fileNames.length - 1 ? ', ' : ''}
                  </span>
                ))
                : txt}
            </div>
            <div
              className="py-2 bg-warning rounded-pill px-3"
              style={{
                backgroundImage: `linear-gradient(to right, #69809a ,silver, silver,#69809a`,
                whiteSpace: "nowrap",
              }}
            >
              <span className="me-2 d-flex" style={{ fontSize: 12 }}>
                <span className="me-1"> {iconTxt}</span>
                <ImUpload2 color="#677788" />
              </span>
            </div>
          </div>
        </label>
      </>
    );
  };

export { FileInput };